import axiosInstance from '../axiosInstance';

/**
 * Fetch accounts from the API.
 * @param {Object} params
 * @param {string} [params.usage] - 'client' | 'supplier' | 'both' — filters by account_usage
 * @param {boolean} [params.active] - filter by active status
 * @param {string} [params.account_type] - filter by type
 * @param {number} [params.page]
 * @param {number} [params.limit]
 */
export const getAccounts = async (params = {}) => {
  const response = await axiosInstance.get('/finance/accounts', {
    params: { ...params, _t: Date.now() },
    headers: { 'Cache-Control': 'no-cache' },
  });
  if (!response.data.success) {
    throw new Error(response.data.message || 'Failed to fetch accounts');
  }
  return response.data;
};

export const createAccount = async (payload) => {
  const response = await axiosInstance.post('/finance/accounts', payload);
  if (!response.data.success) {
    throw new Error(response.data.message || 'Failed to create account');
  }
  return response.data;
};

export const updateAccount = async (id, payload) => {
  const response = await axiosInstance.put(`/finance/accounts/${id}`, payload);
  if (!response.data.success) {
    throw new Error(response.data.message || 'Failed to update account');
  }
  return response.data;
};
